import React from "react";
import { Image, StyleSheet, TouchableOpacity, View } from "react-native";
import Text from "@components/CustomText";
import Report from "@assets/images/HomepageWidget/report.png";
import ChevronRight from "@assets/svg/ChevronRight";
import GoldenStar from "@assets/svg/GoldenStar";
import color from "@constants/color";
import analytics from "@services/analytics";
import { useNavigation } from "@react-navigation/native";
import { width } from "@constants/metrics";
import LoadingComponent from "./LoadingComponent";

const LargeWidget = React.memo(({ item }) => {
  const navigation = useNavigation();
  const getImage = (type) => {
    switch (type) {
      case "todays-report":
        return Report;
      default:
        return null;
    }
  };

  const isloading = (key) => {
    return item?.loading?.includes(key);
  };

  return (
    <TouchableOpacity
      testID="hpw-large-widget"
      style={styles.container}
      activeOpacity={0.8}
      disabled={item?.nav_to === ""}
      onPress={() => {
        if (item?.nav_to) {
          analytics.trackEvent(`${item?.type} Card Clicked`, {
            source: "Home Page Widget",
          });
          navigation.navigate(item?.nav_to, { nav_params: item?.nav_params });
        }
      }}
    >
      <View style={styles.header}>
        <Text variant="subtitle_16">{item?.title}</Text>
        <View style={styles.headerContent}>
          {item?.nav_value > 0 && (
            <View style={styles.headerContent}>
              <GoldenStar fill="#FFB800" />
              <Text variant="title_16" style={styles.navValue}>
                {item?.nav_value}
              </Text>
            </View>
          )}
          <View style={styles.chevronContainer}>
            <ChevronRight
              pathFill={color.lightMediumBlack}
              style={styles.chevronIcon}
            />
          </View>
        </View>
      </View>
      <View style={styles.divider} />
      <View style={styles.footer}>
        <View style={styles.footerContent}>
          <Text variant="caption_2" style={styles.subtitle}>
            {item?.subtitle}
          </Text>
          {item?.value ? (
            <LoadingComponent
              visible={!isloading("value")}
              style={[
                styles.valueContainer,
                isloading("value") && {
                  marginVertical: 6,
                  width: "100%",
                },
              ]}
            >
              <View style={styles.valueContainer}>
                <Text variant="heading_24" style={styles.value}>
                  {item?.value}
                </Text>
                {item?.subvalue ? (
                  <Text variant="caption_3" style={styles.subvalue}>
                    {item?.subvalue}
                  </Text>
                ) : null}
              </View>
            </LoadingComponent>
          ) : null}
          {item?.caption_txt ? (
            <LoadingComponent
              visible={!isloading("caption_value")}
              style={[
                styles.captionContainer,
                isloading("caption_value") && {
                  width: "100%",
                },
              ]}
            >
              <View style={styles.captionContainer}>
                <Text
                  variant="caption_3"
                  style={[
                    styles.captionTxt,
                    item?.caption_color && { color: item?.caption_color },
                  ]}
                >
                  {item?.caption_txt}
                </Text>
                <Text
                  variant="caption_3"
                  style={[
                    styles.captionValue,
                    item?.caption_color && { color: item?.caption_color },
                  ]}
                >
                  {item?.caption_value}
                </Text>
                {item?.caption_icon === "arrow" ? (
                  <ChevronRight
                    pathFill={item?.caption_color}
                    style={{ height: 9, width: 9 }}
                  />
                ) : null}
              </View>
            </LoadingComponent>
          ) : null}
        </View>
        <Image source={getImage(item?.type)} style={styles.image} />
      </View>
    </TouchableOpacity>
  );
});

export default LargeWidget;

const styles = StyleSheet.create({
  container: {
    borderRadius: 16,
    width: width - 32,
    backgroundColor: color.white,
    height: 139,
    elevation: 2,
    marginHorizontal: 6,
    padding: 12,
    overflow: "hidden",
    marginVertical: 8,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  headerContent: {
    flexDirection: "row",
  },
  navValue: {
    marginHorizontal: 4,
  },
  chevronContainer: {
    backgroundColor: color.lightGrayWhite,
    alignSelf: "flex-start",
    padding: 3,
    borderRadius: 4,
  },
  chevronIcon: {
    height: 16,
    width: 16,
  },
  divider: {
    backgroundColor: color.shadowLighter,
    height: 2,
    width: "100%",
    marginVertical: 8,
  },
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignContent: "center",
  },
  footerContent: {
    flexDirection: "column",
    justifyContent: "flex-start",
    marginLeft: 4,
  },
  subtitle: {
    fontSize: 11,
    color: color.mediumBlacklightBlack,
  },
  valueContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  value: {
    color: color.mediumBlack,
  },
  subvalue: {
    color: color.mediumBlacklightBlack,
    marginLeft: 4,
    marginTop: 8,
  },
  captionContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  captionTxt: {
    color: color.primary,
  },
  captionValue: {
    color: color.primary,
    marginLeft: 4,
  },
  image: {
    bottom: 25,
  },
});
